import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { CONTACT, SERVICES } from '../data';
import { fetchServicePreviews } from '../lib/contentful/services/services';
import './Footer.css';

export default function Footer() {
  const fallbackServices = useMemo(
    () =>
      SERVICES.map((service) => ({
        id: service.id,
        title: service.title,
      })),
    []
  );
  const [services, setServices] = useState(fallbackServices);

  useEffect(() => {
    let isActive = true;

    async function loadFooterContent() {
      try {
        const servicePreviews = await fetchServicePreviews();

        if (!isActive) return;

        if (servicePreviews.length) {
          setServices(
            servicePreviews.map((service) => ({
              id: service.id,
              title: service.title,
            }))
          );
        }
      } catch {
        // Keep local fallback content if Contentful is unavailable.
      }
    }

    loadFooterContent();

    return () => {
      isActive = false;
    };
  }, [fallbackServices]);

  return (
    <footer className="footer">
      <div className="footer__inner container">
        <div className="footer__brand">
          <div className="footer__brand-mark">
            <span className="footer__brand-xbc">XBC</span>
            <span className="footer__brand-solutions">Solutions</span>
          </div>
          <p className="footer__copy">
            © {new Date().getFullYear()} · All rights reserved
          </p>
        </div>

        <div className="footer__links">
          <div className="footer__col">
            <h4 className="footer__col-title">Services</h4>
            {services.map((service) => (
              <Link key={service.id} to={`/services/${service.id}`}>
                {service.title}
              </Link>
            ))}
          </div>
          <div className="footer__col">
            <h4 className="footer__col-title">Contact</h4>
            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <div className="container">
          <span>Built with intention · Designed for results</span>
        </div>
      </div>
    </footer>
  );
}
